// TODO(kara): Revisit why error messages are not being properly set.
import {CoreError} from './aliases';
/**
 * Wrapper around Error that sets the error message.
 */
export class Error extends CoreError {
    constructor(value: string) {
        super();
        this.message = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/error/error.class.ts